import { render, staticRenderFns } from "./PostFiles.vue?vue&type=template&id=7a783b7a&scoped=true"
import script from "./PostFiles.vue?vue&type=script&lang=js"
export * from "./PostFiles.vue?vue&type=script&lang=js"
import style0 from "./PostFiles.vue?vue&type=style&index=0&id=7a783b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a783b7a",
  null
  
)

export default component.exports